import React from 'react'
import { Select } from '@surecompanies/core_components'
import { FilterGroup, FilterLabel } from './styles'
import { filterUserSelectOption } from './helpers'
import type { UserOption } from './types'
import { PaymentAssignmentRole } from '../Utils/roles'

interface PaymentAssignmentFilterUserSelectProps {
  label: string
  value: number[]
  onChange: (ids: number[]) => void
  options: UserOption[]
  loading: boolean
  disabled?: boolean
}

export default function PaymentAssignmentFilterUserSelect({
  label,
  value,
  onChange,
  options,
  loading,
  disabled = false,
}: PaymentAssignmentFilterUserSelectProps) {
  return (
    <FilterGroup>
      <FilterLabel>{label}</FilterLabel>
      <Select
        mode="multiple"
        placeholder="All"
        value={value}
        loading={loading}
        disabled={disabled}
        showSearch
        filterOption={filterUserSelectOption}
        onChange={(selectValue) => {
          const ids = (Array.isArray(selectValue) ? selectValue : [])
            .map((v) => Number(v))
            .filter((n) => Number.isFinite(n))
          onChange(ids)
        }}
        style={{ width: '100%' }}
        maxTagCount={value.length >= 2 ? 0 : 'responsive'}
        maxTagPlaceholder={
          value.length >= 2
            ? (omittedValues: { length: number }) =>
                `${omittedValues.length} items selected`
            : undefined
        }
      >
        {options.map((u) => {
          const displayName =
            u.role === PaymentAssignmentRole.CHECKER
              ? `${u.name} (CHECKER)`
              : u.name

          return (
            <Select.Option
              key={u.id}
              value={u.id}
              data-search={`${u.name} ${u.role ?? ''} ${u.id}`}
            >
              {displayName}
            </Select.Option>
          )
        })}
      </Select>
    </FilterGroup>
  )
}
